<script lang="ts">
  import type { DividerVariant, Theme } from '.';

  import IconWrapper from '$mds/IconWrapper';
  import IconCrown from '$assets/svgs/crown.svg?component';

  export let variant: DividerVariant = 'crown';
  export let theme: Theme = 'dark';
  export let text: string = '';
  let className = '';
  export { className as class };

  $: if (text) {
    variant = 'text';
  }
</script>

<!-- gap-2 -->
<div class="flex w-full items-center {className}">
  {#if variant === 'line'}
    <div class="h-px w-full {theme === 'dark' ? 'bg-ondark-high' : 'bg-onlight-base'}" />
  {:else}
    <div
      class="h-px w-full bg-gradient-to-r from-transparent {theme === 'dark' ? 'to-ondark-high' : 'to-onlight-base'}"
    />

    {#if variant === 'crown'}
      <IconWrapper
        icon={IconCrown}
        size="md"
        class="mx-2 !items-start {theme === 'dark' ? 'text-onlight-secondary' : 'text-ondark-secondary'}"
      />
    {:else if variant === 'text'}
      <p class="text-body-sm text-ondark-subtle mx-6 uppercase">
        {text}
      </p>
    {/if}

    <div
      class="h-px w-full bg-gradient-to-l from-transparent {theme === 'dark' ? 'to-ondark-high' : 'to-onlight-base'}"
    />
  {/if}
</div>
